import ReportsRoutes from "./reports/routes";
const Calendar = () => import("./calendar/Calendar.vue");
import mobileClocksRoutes from "./mobileclocks/routes";
import overtimeRoutes from "./overtime/routes";
export default [
  {
    path: "reports",
    redirect: "/ess/attendance/reports/generate",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: ReportsRoutes,
  },
  {
    path: "mobile-clocks",
    redirect: "/ess/attendance/mobile-clocks/approvals",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: mobileClocksRoutes,
  },
  {
    path: "overtime",
    redirect: "/ess/attendance/overtime/all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: overtimeRoutes,
  },
  {
    path: "calendar",
    component: Calendar,
  },
];
